import React, {useEffect, useLayoutEffect} from "react";
// @ts-ignore
import {Previewer} from "pagedjs";
import DashboardReport from "./DashboardReportWrapper";
import {isProd, queryParam} from "utils/utils";
import {useGetDashboard} from "api/api-hooks/dashboards-hooks";

declare global {
    interface Window {
        loadedPreview: boolean;
    }

    interface Element {
        style: any;
    }
}

export const DashboardReportViewPaged = () => {
    const dashboardId = parseInt(queryParam("dashboardId")!!);
    const referenceTime = queryParam("referenceTime");
    const isBot = queryParam("robot") === "true";

    const query = useGetDashboard(dashboardId);
    const reportOptions = query.data?.reportOptions;

    const isValid = () => {
        if(!referenceTime) return false;

        // Check if date valid
        const date = new Date(referenceTime);
        return !isNaN(date.getTime());
    };

    const renderPagePreview = () => {
        console.log("renderPagePreview start", new Date().getTime());
        window.loadedPreview = true;

        const rootEl = document.querySelector("#root")!!;
        const pagedPreviewEl = document.querySelector("#preview-paged")!!;

        // Inline style for pagedjs margin sizes
        const pagedJsStyleInline= { [window.location.href]:
            `@page {
                size: ${reportOptions!!.pageLayout?.format?.pageSize ?? "A4"} ${(reportOptions!!.pageLayout?.format?.orientation ?? "PORTRAIT").toLowerCase()};
                margin-top: ${reportOptions!!.pageLayout?.margins?.top ?? "20mm"};
                margin-bottom: ${reportOptions!!.pageLayout?.margins?.bottom ?? "20mm"};
                margin-left: ${reportOptions!!.pageLayout?.margins?.left ?? "20mm"};
                margin-right: ${reportOptions!!.pageLayout?.margins?.right ?? "20mm"};
                padding-top: ${reportOptions!!.pageLayout?.paddings?.top ?? "0"};
                padding-bottom: ${reportOptions!!.pageLayout?.paddings?.bottom ?? "0"};
                padding-left: ${reportOptions!!.pageLayout?.paddings?.left ?? "0"};
                padding-right: ${reportOptions!!.pageLayout?.paddings?.right ?? "0"};
            }
        `}

        const previewer = new Previewer();
        const polisher = previewer.polisher;
        const chunker = previewer.chunker;
        previewer.preview(
            rootEl.innerHTML,
            [`${window.jsBasePath}/assets/reports/core.css`, pagedJsStyleInline],
            pagedPreviewEl
        ).then((flow: any) => {
            document.querySelector("#dashboard-report-wrapper-paged")!!.style.display = "none"
            console.log("Rendered", flow.total, "pages.");
            console.log("renderPagePreview end", new Date().getTime());
        })
    }

    useEffect(() => {
        console.log("Robot?", isBot);
    }, []);


    useLayoutEffect(() => {
        if(!isValid()) return;
        if(!query.data) return;
        if(window.loadedPreview) return;

        setTimeout(() => {
            renderPagePreview();
        }, isProd() ? 4000 : 1000);
    });

    return <React.Fragment>
        {!isValid() && <div>Invalid report options (missing or invalid referenceTime)</div>}

        { isValid() && !query.data && "Loading..." }

        { isValid() && query.data &&
            <DashboardReport dashboard={query.data} referenceTime={referenceTime!!}/>
        }
    </React.Fragment>
};

